var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWebProfit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 691.58 481.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f35a3a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M666.25,0h-104.05c-9.58,0-18.34,5.41-22.63,13.99l-83.97,167.94,80.31,160.62L688.88,36.61c8.41-16.82-3.82-36.61-22.63-36.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M530.6,372.01c-.41-2.38-1.18-4.75-2.34-7.08l-1.77-3.54-80.31-160.62-4.71-9.42-4.71-9.42-43.81-87.63c-4.28-8.57-13.05-13.98-22.63-13.98h-104.05c-18.81,0-31.04,19.79-22.63,36.61l112.81,225.62,4.71,9.42,4.71,9.42,13.08,26.17c4.29,8.57,13.05,13.98,22.63,13.98h104.05c.26,0,.53,0,.79-.01,3.95-.11,7.6-1.11,10.8-2.76h0c9.6-4.95,15.27-15.81,13.38-26.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.79,401.55l-4.71-9.42h0l-4.71-9.43L152.01,13.99C147.72,5.41,138.96,0,129.38,0H25.33C6.53,0-5.71,19.79,2.7,36.61l215.63,431.26c4.28,8.57,13.04,13.99,22.63,13.99h104.05c.26,0,.52,0,.78-.01,18.36-.53,30.14-20.01,21.85-36.6l-21.85-43.7h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWebProfit1);
export default __webpack_public_path__ + "static/media/LogoWebProfit1.bcd79c39aa48e6f61f5024cb7cc07fa7.svg";
export { ForwardRef as ReactComponent };